import React from 'react'
import _ from '/home/ps/root'
import vw from '/home/ps/view/view'
import {go} from '../../../io'
import './index.css'
// import {
//   masterPropType,
//   masterStateToProp,
//   masterDispatchToProp,
// } from '../../../type'
export const ID = 'banner'
export const MasterBanner = prop => {
  const {lang, master, u, owner, cookie}=prop.master
  const q = u=='store' || _.Q_.includes(u)
  const onWelcome = e => {
    e.stopPropagation()
    // go(prop.history.push, [lang, 'master', 'page'])
    go(prop.history.push, ['master', 'page'])
  }
  // const p = {id:ID, onClick}
  const minHeight = q ? `${vw.HEIGHT}px` : `${vw.HEIGHT*3/2}px`
  // <div  className={`h1 ${_.THEME} ${_.CENTER}`}>
  //   <span>
  //     {master[_.WELCOME][_.I]}
  //   </span>
  // </div>
  // const onEdit = e => go(prop.history.push, [lang, cookie.username, 'edit'])
  const onEdit = e => go(prop.history.push, [cookie.username, 'edit'])
  return (
    <div>
      <div style={{minHeight}}></div>
      {q &&
        <div  className='h1 theme center'>
          <span onClick={onWelcome}>
            {master.welcome.i}
          </span>
        </div>
      }
      {/*q && owner &&
        <div className={`${_.FLEX} ${_.CENTER}`} style={{justifyContent: 'center'}}>
          <button onClick={onEdit}>
            {master[_.EDIT][_.I]} {master[_.STORE][_.I]}
          </button>
        </div>
      */}
      <div style={{minHeight: `${vw.HEIGHT/4}px`}}></div>
    </div>
  )
}
// MasterBanner.propTypes = masterPropType;
// export default connect(
//   masterStateToProp,
//   masterDispatchToProp
// )(MasterOutOfBand)
MasterBanner.ID = ID
export default MasterBanner
